// ==================================================
// FILE: themeConfig.js (Main config import file)
// ==================================================

import vanillaBundle from './themes/vanilla';
import majesticBundle from './themes/majestic';
import devastatorsBundle from './themes/devastators';
import archboundBundle from './themes/archbound';

// Extract theme configurations from bundles
export const THEMES = {
  vanilla: vanillaBundle.theme,
  majestic: majesticBundle.theme,
  devastators: devastatorsBundle.theme,
  archbound: archboundBundle.theme
};

// Export full bundles for accessing events, story, and other content
export const THEME_BUNDLES = {
  vanilla: vanillaBundle,
  majestic: majesticBundle,
  devastators: devastatorsBundle,
  archbound: archboundBundle
};

// Helper function for color classes
export const getColorClasses = (color, type = 'text') => {
  const colorMap = {
    red: { 
      text: 'text-red-400', 
      bg: 'bg-red-500/20', 
      border: 'border-red-500', 
      borderHover: 'hover:border-red-500', 
      shadow: 'hover:shadow-red-500/30',
      alertBg: 'bg-red-900/30',
      alertBorder: 'border-red-500',
      alertText: 'text-red-300',
      bgMain: 'bg-red-500',
      bgHover: 'hover:bg-red-600'
    },
    blue: { 
      text: 'text-blue-400', 
      bg: 'bg-blue-500/20', 
      border: 'border-blue-500', 
      borderHover: 'hover:border-blue-500', 
      shadow: 'hover:shadow-blue-500/30',
      bgMain: 'bg-blue-500',
      bgHover: 'hover:bg-blue-600'
    },
    cyan: { 
      text: 'text-cyan-400', 
      bg: 'bg-cyan-500', 
      borderHover: 'hover:bg-cyan-400', 
      shadow: 'hover:shadow-cyan-500/30',
      bgFrom: 'from-cyan-900/20',
      bgVia: 'via-blue-900/20',
      bgTo: 'to-cyan-900/20',
      borderMain: 'border-cyan-500/50',
      bgAccent: 'bg-cyan-500/10',
      pulseText: 'text-cyan-400/70',
      bgMain: 'bg-cyan-500',
      bgHover: 'hover:bg-cyan-600'
    },
    green: {
      text: 'text-green-400',
      bg: 'bg-green-500/20',
      border: 'border-green-500',
      borderHover: 'hover:border-green-500',
      shadow: 'hover:shadow-green-500/30',
      alertBg: 'bg-green-900/30',
      alertBorder: 'border-green-500',
      alertText: 'text-green-300',
      bgMain: 'bg-green-500',
      bgHover: 'hover:bg-green-600'
    },
    emerald: {
      text: 'text-emerald-400',
      bg: 'bg-emerald-500',
      borderHover: 'hover:bg-emerald-400',
      shadow: 'hover:shadow-emerald-500/30',
      bgFrom: 'from-emerald-900/20',
      bgVia: 'via-green-900/20',
      bgTo: 'to-emerald-900/20',
      borderMain: 'border-emerald-500/50',
      bgAccent: 'bg-emerald-500/10',
      pulseText: 'text-emerald-400/70',
      bgMain: 'bg-emerald-500',
      bgHover: 'hover:bg-emerald-600'
    },
    purple: {
      text: 'text-purple-400',
      bg: 'bg-purple-500/20',
      border: 'border-purple-500',
      borderHover: 'hover:border-purple-500',
      shadow: 'hover:shadow-purple-500/30',
      alertBg: 'bg-purple-900/30',
      alertBorder: 'border-purple-500',
      alertText: 'text-purple-300',
      bgMain: 'bg-purple-500',
      bgHover: 'hover:bg-purple-600'
    },
    indigo: {
      text: 'text-indigo-400',
      bg: 'bg-indigo-500/20',
      border: 'border-indigo-500',
      borderHover: 'hover:border-indigo-500',
      shadow: 'hover:shadow-indigo-500/30',
      bgMain: 'bg-indigo-500',
      bgHover: 'hover:bg-indigo-600'
    },
    violet: {
      text: 'text-violet-400',
      bg: 'bg-violet-500',
      borderHover: 'hover:bg-violet-400',
      shadow: 'hover:shadow-violet-500/30',
      bgFrom: 'from-violet-900/20',
      bgVia: 'via-purple-900/20',
      bgTo: 'to-violet-900/20',
      borderMain: 'border-violet-500/50',
      bgAccent: 'bg-violet-500/10',
      pulseText: 'text-violet-400/70',
      bgMain: 'bg-violet-500',
      bgHover: 'hover:bg-violet-600'
    },
    amber: { 
      text: 'text-amber-400', 
      bg: 'bg-amber-500/20', 
      border: 'border-amber-500', 
      borderHover: 'hover:border-amber-500', 
      shadow: 'hover:shadow-amber-500/30',
      bgMain: 'bg-amber-500',
      bgHover: 'hover:bg-amber-600'
    },
    orange: { 
      text: 'text-orange-400', 
      bg: 'bg-orange-500/20', 
      border: 'border-orange-500', 
      borderHover: 'hover:border-orange-500', 
      shadow: 'hover:shadow-orange-500/30',
      alertBg: 'bg-orange-900/30',
      alertBorder: 'border-orange-500',
      alertText: 'text-orange-300',
      bgMain: 'bg-orange-500',
      bgHover: 'hover:bg-orange-600'
    },
    yellow: { 
      text: 'text-yellow-400', 
      bg: 'bg-yellow-500', 
      borderHover: 'hover:bg-yellow-400', 
      shadow: 'hover:shadow-yellow-500/30',
      bgFrom: 'from-yellow-900/20',
      bgVia: 'via-amber-900/20',
      bgTo: 'to-yellow-900/20',
      borderMain: 'border-yellow-500/50',
      bgAccent: 'bg-yellow-500/10',
      pulseText: 'text-yellow-400/70',
      bgMain: 'bg-yellow-500',
      bgHover: 'hover:bg-yellow-600'
    }
  };
  return colorMap[color]?.[type] || colorMap.blue[type];
};